import React from 'react';
import PropTypes from 'prop-types';
import {
  Wrapper,
  Header,
  MinMaxValues,
  Stepper,
  SubmitButton,
  Animation,
} from '../SliderComponents';
import {RangeSlider} from '@learningblocks/shared-components';
import {Colours} from '@learningblocks/shared-components';

import './style.scss';

export function SliderMob(props) {
  return (
    <Wrapper className='slider_container' ariaLabel={props.animeAriaLabel}>
      <Header className='slider_container_heading' text={props.animationText} />
      <figure className='fullWidthAnimation'>
        <Animation
          className='slider_container_animation'
          frame={props.value}
          animation={props.animation}
        />
        <figcaption style={{display: (props.animationCaption)?'initial':'none'}}>{props.animationCaption}</figcaption>
      </figure>
      <RangeSlider
        customThumb={false}
        value={props.value}
        onChange={props.onChange}
        step={props.step}
        min={props.min}
        max={props.max}
        leftPortionColour={Colours.colorPrimaryTone80}
        ariaLabel={props.sliderAriaLabel}
      />
      <Wrapper className='slider_container_sliderblock'>
        <Header
          className='slider_container_sliderblock_title'
          text={props.sliderText}
        />
        <Stepper
          valueType={props.valueType}
          currentValue={props.value}
          onChange={props.onChange}
          min={props.min}
          max={props.max}
          step={props.step}
        />
        <MinMaxValues
          className={'sliderMob_minmax'}
          min={`Min: ${props.min}`}
          max={`Max: ${props.max}`}
          valueType={props.valueType}
        />
      </Wrapper>
    </Wrapper>
  );
}

SliderMob.propTypes = {
  /**
   *  text above animation
   */
  animationText: PropTypes.string,
  /**
   * Slider text
   */
  sliderText: PropTypes.string,
  /**
   * Current value of slider
   */
  value: PropTypes.number,
  /**
   * function to invoke on rangeSlider onChange
   */
  onChange: PropTypes.func,
  /**
   * lower limit of slider
   */
  min: PropTypes.number,
  /**
   * upper limit for slider
   */
  max: PropTypes.number,
  /**
   * specifies type of value supplied
   */
  valueType: PropTypes.oneOf(['precise', 'vague']),
  /**
   * bool value to show submit button
   */
  showSubmit: PropTypes.bool,
  /**
   * aria label for animation
   */
  animeAriaLabel: PropTypes.string,
  /**
   * aria label for range slider
   */
  sliderAriaLabel: PropTypes.string,
  /**
   * specifies how much units is one step for rangeSlider
   */
  step: PropTypes.number,
};

SliderMob.defaultProps = {
  animationText: 'Tab the - and + buttons to see the change of []',
  sliderText: 'Temperature',
  valueType: 'precise',
  showSubmit: false,
  min: 0,
  max: 100,
  step: 1,
};
